/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".icon-category-tree-invisible[_ngcontent-%COMP%]{display:none}.icon-category-tree[_ngcontent-%COMP%]   li[_ngcontent-%COMP%], .icon-category-tree[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin-top:0;margin-bottom:0;list-style-type:none}mat-card[_ngcontent-%COMP%]{margin-top:24px}mat-card[_ngcontent-%COMP%]   mat-card-subtitle[_ngcontent-%COMP%]{text-align:center}mat-card[_ngcontent-%COMP%]   mat-card-content[_ngcontent-%COMP%]{padding-top:16px}"];
export { styles as styles };
